exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".admin-email .preview,.admin-email .binary>div{border:1px solid #000;padding:10px;background:#fff;margin:10px 0}.admin-email .binary{display:flex}.admin-email .binary textarea{width:40%;margin-right:20px;min-height:200px}.admin-email .binary>div{flex-grow:1}.admin-email .diag-preview>div{max-width:900px}", ""]);

